import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\CompanyShareholderController::destroy
* @see app/Http/Controllers/Investors/CompanyShareholderController.php:13
* @route '//app.finesthub.de/shareholders/{naturalPerson}'
*/
export const destroy = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/shareholders/{naturalPerson}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\CompanyShareholderController::destroy
* @see app/Http/Controllers/Investors/CompanyShareholderController.php:13
* @route '//app.finesthub.de/shareholders/{naturalPerson}'
*/
destroy.url = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { naturalPerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { naturalPerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
    }

    return destroy.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompanyShareholderController::destroy
* @see app/Http/Controllers/Investors/CompanyShareholderController.php:13
* @route '//app.finesthub.de/shareholders/{naturalPerson}'
*/
destroy.delete = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const CompanyShareholderController = { destroy }

export default CompanyShareholderController